import { render, staticRenderFns } from "./error.vue?vue&type=template&id=181dd634&lang=pug&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181dd634')) {
      api.createRecord('181dd634', component.options)
    } else {
      api.reload('181dd634', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=181dd634&lang=pug&", function () {
      api.rerender('181dd634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error.vue"
export default component.exports